import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, Mail } from "lucide-react";
import { BUSINESS } from "../constants/business";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#050505]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <div className="flex items-center gap-3 mb-5">
          <span className="w-3 h-3 bg-[#E60000]" />
          <span className="font-display text-2xl uppercase tracking-wide pt-1">
            Mario <span className="text-zinc-500">Auto Body</span>
          </span>
        </div>
        <p className="text-zinc-500 text-sm leading-relaxed max-w-xs">
          Professional collision and auto body repair in Jessup, MD. Quality workmanship and honest service to get you safely back on the road.
        </p>
      </div>
      <div>
        <p className="font-mono2 text-xs tracking-[0.3em] uppercase text-zinc-500 mb-5">Navigate</p>
        <nav className="flex flex-col gap-3" data-testid="footer-nav">
          <Link to="/" data-testid="footer-link-home" className="text-zinc-400 hover:text-white text-sm transition-colors">Home</Link>
          <Link to="/estimate" data-testid="footer-link-estimate" className="text-zinc-400 hover:text-white text-sm transition-colors">Submit an Estimate</Link>
          <Link to="/contact" data-testid="footer-link-contact" className="text-zinc-400 hover:text-white text-sm transition-colors">Contact</Link>
        </nav>
      </div>
      <div>
        <p className="font-mono2 text-xs tracking-[0.3em] uppercase text-zinc-500 mb-5">Visit Us</p>
        <div className="flex flex-col gap-4 text-sm text-zinc-400">
          <span className="flex items-start gap-3" data-testid="footer-address">
            <MapPin size={16} className="text-[#E60000] mt-0.5 shrink-0" />
            {BUSINESS.address}<br />{BUSINESS.city}
          </span>
          <a href={BUSINESS.phoneHref} data-testid="footer-phone" className="flex items-center gap-3 hover:text-white transition-colors">
            <Phone size={16} className="text-[#E60000] shrink-0" /> {BUSINESS.phone}
          </a>
          <span className="flex items-center gap-3" data-testid="footer-email">
            <Mail size={16} className="text-[#E60000] shrink-0" /> {BUSINESS.email}
          </span>
          <span className="flex items-start gap-3" data-testid="footer-hours">
            <Clock size={16} className="text-[#E60000] mt-0.5 shrink-0" />
            Mon – Fri: 8:00 AM – 3:00 PM<br />Sat – Sun: Closed
          </span>
        </div>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-2">
        <p className="font-mono2 text-xs text-zinc-600">© {new Date().getFullYear()} {BUSINESS.name}. All rights reserved.</p>
        <p className="font-mono2 text-xs text-zinc-600">{BUSINESS.address}, {BUSINESS.city}</p>
      </div>
    </div>
  </footer>
);
